import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { Link } from "react-router-dom";

const own = (f) => `/images/${f}`;

const tiles = [
  { video: own("gallery-video.mp4"), poster: own("gallery-video-poster.jpg"), label: "Live in Motion", tag: "Watch the Energy", span: "md:col-span-4", h: "h-[28rem]" },
  { src: own("dj3.webp"), label: "In His Element", tag: "Dream Entertainment", span: "md:col-span-8", h: "h-[28rem]" },
  { src: own("dj7.webp"), label: "The LED Robot & Dhol", tag: "Special Moments", span: "md:col-span-4", h: "h-96" },
  { src: own("dj1.webp"), label: "Behind the Booth", tag: "Receptions", span: "md:col-span-4", h: "h-96" },
  { src: own("dj8.webp"), label: "Golden Hour Set", tag: "Receptions", span: "md:col-span-4", h: "h-96" },
  { src: own("dj5.webp"), label: "Late Night Sessions", tag: "Dream Entertainment", span: "md:col-span-4", h: "h-96" },
  { src: own("dj6.webp"), label: "Backyard Setup", tag: "Backyard Parties", span: "md:col-span-4", h: "h-96" },
  { video: own("gallery-video-2.mp4"), poster: own("gallery-video-2-poster.jpg"), label: "Crowd on Fire", tag: "Watch the Energy", span: "md:col-span-4", h: "h-96" },
];

export default function Gallery() {
  return (
    <main data-testid="gallery-page">
      <PageHeader
        overline="Moments We've Made"
        title="The"
        accent="gallery."
        description="A glimpse into the nights we've soundtracked: weddings, sangeets, birthdays and every celebration in between."
      />

      <section className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {tiles.map((t, i) => (
            <Reveal key={t.label + i} delay={(i % 3) * 0.1} className={t.span}>
              <div
                data-testid={t.video ? "gallery-video-tile" : `gallery-tile-${i}`}
                className={`group relative overflow-hidden rounded-2xl border border-white/5 ${t.h}`}
              >
                {t.video ? (
                  <video
                    src={t.video}
                    poster={t.poster}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                ) : (
                  <img
                    src={t.src}
                    alt={t.label}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-[transform,opacity] duration-500">
                  <p className="text-[10px] tracking-[0.3em] uppercase text-primary">
                    {t.tag}
                  </p>
                  <p className="font-serif text-2xl mt-1">{t.label}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="text-center mt-20">
          <p className="font-serif text-3xl sm:text-4xl tracking-tight">
            Your celebration could be <em className="text-primary">next.</em>
          </p>
          <Link
            to="/booking"
            data-testid="gallery-cta-btn"
            className="mt-8 inline-block rounded-full bg-primary text-primary-foreground px-10 py-4 text-sm font-medium tracking-widest uppercase transition-[transform,box-shadow] duration-300 hover:scale-105 hover:shadow-[0_0_40px_rgba(255,0,127,0.4)]"
          >
            Book Your Date
          </Link>
        </Reveal>
      </section>
    </main>
  );
}
